module.exports = __webpack_public_path__ + "img/logo-2.66621786.png";